import { Environment } from './model';

export const environment: Environment = {
    production: true,
    dbName: 'cloudpilot-preview',
    releaseExtra: 'preview',
    localStorageSuffix: 'preview',
    debug: true,
};
